import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note16',
  templateUrl: './note16.component.html',
  styleUrls: ['./note16.component.scss'],
})
export class Note16Component implements OnInit {
  note16Form: FormGroup;
  calculativeDate: any;

  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      if (data.noteId === Notes.Note16) {
        this.calculativeDate = data.response.calculativeData;
        if (
          data.response.userInputData !== null &&
          data.response.userInputData !== undefined &&
          data.response.userInputData.data !== null &&
          data.response.userInputData.data !== undefined
        ) {
          this.editNotes16(data.response.userInputData.data);
        }
      }
    });
  }
  editNotes16(res): void {
    this.note16Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : '',
    });
  }

  setForm(): void {
    this.note16Form = new FormGroup({
      textbox1: new FormControl(''),
    });
  }
}
